module.exports = __webpack_public_path__ + "img/guess.a049563d.svg";